export const RecommendedSegmentsTab = () => {
  return <div>Recommended Segments</div>;
};
